import * as React from "react";

const ClinicaDelSol = ({
  size = 56,
  primaryColor = "#00205c",
  secondaryColor = "#ffffff",
  ...props
}) => {
  const uid = React.useId();
  const clipPathId = `clipClinicaDelSol-${uid}`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Capa_1"
      data-name="Capa 1"
      viewBox="0 0 1080 1080"
      width={size}
      height={size}
      {...props}
    >
      <defs>
        <clipPath id={clipPathId}>
          <path
            d="M1039.21,540.01c0,275.71-223.51,499.2-499.22,499.2S40.79,815.71,40.79,540.01,264.28,40.79,539.99,40.79s499.22,223.49,499.22,499.21Z"
            fill="none"
          />
        </clipPath>
      </defs>

      <g>
        <path
          d="M1039.21,540.01c0,275.71-223.51,499.2-499.22,499.2S40.79,815.71,40.79,540.01,264.28,40.79,539.99,40.79s499.22,223.49,499.22,499.21Z"
          fill={primaryColor}
        />

        <g clipPath={`url(#${clipPathId})`}>
          <g>
            <path
              d="M621.13,165.78c-7.23-7.44-28.68-25.32-68.51-19.37,0,0,50.21-60.48,111.4-8.47,0,0,37.29,33.09,78.84,15.62,0,0-58.94,71.9-118.53,15.13,0,0-1.36-.99-3.2-2.91Z"
              fill={secondaryColor}
              stroke={secondaryColor}
              strokeMiterlimit={10}
              strokeWidth={0.28}
            />
            <path
              d="M648.48,265.63c-10.36,0-38.17,2.91-61.63,35.63,0,0-8.4-78.14,71.53-85.77,0,0,49.7-3.72,66.12-45.72,0,0,10.51,92.39-71.68,95.59,0,0-1.71.27-4.35.27Z"
              fill={secondaryColor}
              stroke={secondaryColor}
              strokeMiterlimit={10}
              strokeWidth={0.28}
            />
            <path
              d="M648.44,265.73c-10.4,0-38.18,2.91-61.65,35.57,0,0-8.37-78.12,71.57-85.73,0,0,49.72-3.69,66.14-45.72,0,0,10.47,92.44-71.75,95.59,0,0-1.67.28-4.31.28Z"
              fill={secondaryColor}
              stroke={secondaryColor}
              strokeMiterlimit={10}
              strokeWidth={0.28}
            />
            <path
              d="M739.05,315.72c-7.22,7.44-24.51,29.4-17.41,69.02,0,0-61.86-48.46-11.63-111.08,0,0,32.01-38.26,13.33-79.29,0,0,73.56,56.88,18.56,118.05,0,0-.98,1.4-2.84,3.3Z"
              fill={secondaryColor}
              stroke={secondaryColor}
              strokeMiterlimit={10}
              strokeWidth={0.28}
            />
            <path
              d="M739.05,315.72c-7.22,7.44-24.51,29.4-17.42,69.02,0,0-61.86-48.46-11.63-111.08,0,0,32.01-38.26,13.33-79.29,0,0,73.56,56.88,18.56,118.05,0,0-.98,1.4-2.84,3.3Z"
              fill={secondaryColor}
              stroke={secondaryColor}
              strokeMiterlimit={10}
              strokeWidth={0.28}
            />
            <path
              d="M838.08,285.54c.28,10.35,4,38.06,37.36,60.6,0,0-77.87,10.63-87.78-69.05,0,0-5.1-49.6-47.56-64.81,0,0,92.02-13.11,97.57,68.94,0,0,.34,1.69.41,4.33Z"
              fill={secondaryColor}
              stroke={secondaryColor}
              strokeMiterlimit={10}
              strokeWidth={0.28}
            />
            <path
              d="M838.08,285.54c.28,10.35,3.99,38.06,37.36,60.57,0,0-77.88,10.66-87.78-69.02,0,0-5.1-49.6-47.56-64.81,0,0,92.02-13.11,97.57,68.94,0,0,.34,1.69.41,4.33Z"
              fill={secondaryColor}
              stroke={secondaryColor}
              strokeMiterlimit={10}
              strokeWidth={0.28}
            />

            <g>
              <path
                d="M885.82,196.35c7.47,7.2,29.55,24.36,69.14,17.03,0,0-48.14,62.15-111.03,12.24,0,0-38.41-31.8-79.35-12.9,0,0,56.47-73.87,117.91-19.16,0,0,1.41.96,3.32,2.8Z"
                fill={secondaryColor}
                stroke={secondaryColor}
                strokeMiterlimit={10}
                strokeWidth={0.28}
              />
              <path
                d="M855.11,97.49c10.35-.34,38.06-4.2,60.37-37.7,0,0,11.05,77.85-68.57,88.16,0,0-49.56,5.4-64.56,47.94,0,0-13.6-91.97,68.44-97.96,0,0,1.68-.34,4.32-.44Z"
                fill={secondaryColor}
                stroke={secondaryColor}
                strokeMiterlimit={10}
                strokeWidth={0.28}
              />
              <path
                d="M762.82,50.66c6.97-7.67,23.47-30.23,15-69.57,0,0,63.54,46.3,15.47,110.61,0,0-30.67,39.3-10.59,79.68,0,0-75.48-54.28-22.61-117.3,0,0,.92-1.46,2.72-3.41Z"
                fill={secondaryColor}
                stroke={secondaryColor}
                strokeMiterlimit={10}
                strokeWidth={0.28}
              />
              <path
                d="M664.91,84.25c-.66-10.37-5.33-37.93-39.45-59.27,0,0,77.47-13.32,90.12,66,0,0,6.83,49.39,49.79,63.1,0,0-91.54,16.29-99.92-65.52,0,0-.39-1.66-.54-4.31Z"
                fill={secondaryColor}
                stroke={secondaryColor}
                strokeMiterlimit={10}
                strokeWidth={0.28}
              />
            </g>
          </g>
        </g>
      </g>

      <g>
        <g>
          <path
            d="M344.48,602.24c4,2.26,7.25,5.41,9.77,9.41v-40.61h22.57v114.99h-21.63v-11.8c-3.19,5.07-6.8,8.74-10.86,11.02-4.07,2.3-9.13,3.44-15.17,3.44-9.95,0-18.31-4.01-25.11-12.08-6.81-8.04-10.21-18.38-10.21-30.97,0-14.56,3.34-25.97,10.04-34.31,6.69-8.32,15.63-12.5,26.83-12.5,5.17,0,9.75,1.14,13.76,3.4ZM349.95,662.9c3.28-4.68,4.92-10.74,4.92-18.22,0-10.38-2.63-17.86-7.88-22.33-3.24-2.71-6.98-4.06-11.25-4.06-6.52,0-11.29,2.47-14.33,7.38-3.06,4.91-4.58,11.04-4.58,18.32,0,7.86,1.54,14.15,4.65,18.9,3.09,4.68,7.79,7.03,14.1,7.03s11.09-2.32,14.38-7.02Z"
            fill={secondaryColor}
          />
          <path
            d="M452.55,602.61c5.96,2.65,10.86,6.83,14.72,12.58,3.49,5.07,5.75,10.92,6.79,17.62.59,3.9.84,9.54.74,16.9h-62.02c.34,8.53,3.32,14.54,8.9,17.95,3.4,2.15,7.5,3.22,12.28,3.22,5.06,0,9.21-1.3,12.37-3.93,1.73-1.38,3.25-3.35,4.57-5.87h22.75c-.6,5.07-3.36,10.21-8.27,15.44-7.6,8.27-18.3,12.4-32.02,12.4-11.34,0-21.32-3.49-29.99-10.47-8.66-7.02-13-18.36-13-34.09,0-14.77,3.91-26.08,11.73-33.95,7.82-7.88,17.97-11.8,30.45-11.8,7.41,0,14.1,1.32,20.03,4ZM419.23,621.83c-3.14,3.23-5.13,7.64-5.92,13.18h38.36c-.41-5.91-2.38-10.4-5.94-13.47-3.55-3.04-7.96-4.56-13.2-4.56-5.73,0-10.15,1.62-13.3,4.86Z"
            fill={secondaryColor}
          />
          <path
            d="M508.78,686.03h-22.28v-115.16h22.28v115.16Z"
            fill={secondaryColor}
          />
          <path
            d="M578.09,650.48c.73,5.25,2.2,9.2,4.39,11.8,3.99,4.74,10.81,7.12,20.51,7.12,5.78,0,10.49-.65,14.12-1.9,6.84-2.4,10.29-6.84,10.29-13.36,0-3.8-1.68-6.73-5.05-8.81-3.37-2.02-8.69-3.84-15.99-5.41l-12.46-2.72c-12.25-2.71-20.67-5.66-25.26-8.82-7.75-5.33-11.64-13.62-11.64-24.93,0-10.3,3.79-18.88,11.38-25.73,7.6-6.81,18.75-10.22,33.45-10.22,12.29,0,22.79,3.23,31.46,9.65,8.66,6.43,13.21,15.76,13.64,28.02h-23.13c-.45-6.94-3.53-11.85-9.3-14.79-3.84-1.9-8.62-2.88-14.33-2.88-6.35,0-11.41,1.24-15.22,3.75-3.79,2.47-5.69,5.97-5.69,10.46,0,4.09,1.87,7.2,5.61,9.21,2.41,1.35,7.5,2.96,15.3,4.78l20.2,4.76c8.86,2.08,15.51,4.86,19.92,8.35,6.87,5.41,10.3,13.26,10.3,23.52s-4.07,19.26-12.19,26.21c-8.16,6.97-19.65,10.45-34.49,10.45s-27.08-3.45-35.75-10.3c-8.69-6.84-13.04-16.27-13.04-28.23h22.97Z"
            fill={secondaryColor}
          />
          <path
            d="M736.67,675.63c-7.17,8.87-18.09,13.29-32.72,13.29s-25.55-4.42-32.74-13.29c-7.19-8.9-10.78-19.57-10.78-32.05s3.58-22.93,10.78-31.95c7.18-8.97,18.1-13.49,32.74-13.49s25.56,4.52,32.72,13.49c7.2,9.02,10.79,19.65,10.79,31.95s-3.59,23.14-10.79,32.05ZM718.87,663.29c3.48-4.62,5.23-11.18,5.23-19.71s-1.75-15.1-5.23-19.71c-3.5-4.6-8.49-6.89-15-6.89s-11.52,2.29-15.02,6.89c-3.53,4.61-5.28,11.16-5.28,19.71s1.75,15.1,5.28,19.71c3.5,4.63,8.51,6.96,15.02,6.96s11.51-2.33,15-6.96Z"
            fill={secondaryColor}
          />
          <path
            d="M786.13,686.03h-22.27v-115.16h22.27v115.16Z"
            fill={secondaryColor}
          />
        </g>

        <g>
          <path
            d="M377.49,393.7c8.49,8.14,13.18,17.34,14.07,27.64h-16.13c-1.77-7.77-5.32-14.06-10.69-18.58-5.38-4.53-12.87-6.91-22.5-6.91-11.82,0-21.38,4.19-28.57,12.66-7.28,8.34-10.87,21.29-10.87,38.65,0,14.21,3.33,25.8,9.77,34.6,6.55,8.91,16.32,13.34,29.35,13.34,11.91,0,21.1-4.7,27.23-13.96,3.39-4.93,5.84-11.44,7.45-19.39h16.11c-1.43,12.84-6.05,23.57-14.11,32.16-9.55,10.39-22.45,15.65-38.7,15.65-14.01,0-25.79-4.22-35.18-12.9-12.56-11.29-18.82-28.7-18.82-52.31,0-17.91,4.73-32.67,14.02-44.03,10.2-12.55,24.24-18.74,42.13-18.74,15.26,0,27.04,4.03,35.45,12.11Z"
            fill={secondaryColor}
          />
          <path
            d="M412.47,384.9h14.96v121.38h-14.96v-121.38Z"
            fill={secondaryColor}
          />
          <path
            d="M481,382.09l-22.08,23.95h-11.49l15.16-23.95h18.4ZM454.53,418.25h15.17v88.04h-15.17v-88.04Z"
            fill={secondaryColor}
          />
          <path
            d="M496.98,417.72h14.28v12.63c4.13-5.22,8.62-8.91,13.33-11.2,4.71-2.21,9.87-3.38,15.66-3.38,12.58,0,21.15,4.39,25.54,13.19,2.45,4.81,3.61,11.6,3.61,20.61v56.72h-15.09v-55.76c0-5.38-.88-9.82-2.39-13.07-2.68-5.48-7.52-8.22-14.51-8.22-3.52,0-6.35.34-8.69,1.04-4.13,1.22-7.66,3.61-10.77,7.3-2.49,2.89-4.1,5.82-4.9,9.05-.77,3.12-1.04,7.52-1.04,13.37v46.28h-15.03v-88.57Z"
            fill={secondaryColor}
          />
          <path
            d="M591.49,384.9h15.16v16.85h-15.16v-16.85ZM591.49,418.25h15.16v88.04h-15.16v-88.04Z"
            fill={secondaryColor}
          />
          <path
            d="M687.98,422.54c6.28,4.83,10.03,13.16,11.35,25.01h-14.48c-.93-5.44-2.94-9.98-6.14-13.62-3.14-3.59-8.26-5.46-15.22-5.46-9.44,0-16.34,4.66-20.44,13.96-2.53,5.94-3.87,13.4-3.87,22.24s1.86,16.24,5.61,22.31c3.74,6.05,9.6,9.1,17.75,9.1,6.2,0,11.09-1.85,14.69-5.67,3.66-3.77,6.14-8.82,7.62-15.4h14.48c-1.6,11.73-5.83,20.33-12.55,25.79-6.58,5.35-15.05,8.09-25.35,8.09-11.67,0-20.91-4.26-27.83-12.69-6.95-8.5-10.33-18.97-10.33-31.71,0-15.52,3.74-27.61,11.33-36.31,7.49-8.66,17.19-12.94,28.9-12.94,10.07,0,18.2,2.37,24.49,7.3Z"
            fill={secondaryColor}
          />
          <path
            d="M761.85,452.7c3.35-.39,5.74-1.82,6.93-4.27.61-1.35.98-3.22.98-5.7,0-5.06-1.82-8.79-5.43-11.07-3.61-2.33-8.77-3.48-15.54-3.48-7.82,0-13.27,2.1-16.58,6.34-1.77,2.36-3,5.82-3.54,10.37h-13.95c.28-10.95,3.85-18.54,10.72-22.82,6.77-4.36,14.65-6.46,23.64-6.46,10.48,0,18.97,2,25.45,6.04,6.45,3.84,9.73,10.09,9.73,18.5v50.95c0,1.61.3,2.81.98,3.75.55.91,1.93,1.38,4.07,1.38.48,0,1.38-.05,2.22-.13.78-.08,1.68-.16,2.58-.41v11.07c-2.29.6-4.13,1.06-5.27,1.22-1.29.18-2.92.26-4.97.26-5.18,0-8.92-1.81-11.22-5.45-1.21-1.95-2.05-4.7-2.6-8.25-3,4.01-7.39,7.39-13.08,10.43-5.68,2.84-11.96,4.36-18.88,4.36-8.21,0-14.85-2.55-20.14-7.51-5.18-4.97-7.87-11.25-7.87-18.69,0-8.23,2.61-14.56,7.72-19.16,5.15-4.37,11.83-7.17,20.25-8.34l23.81-2.94ZM730.43,492.96c3.13,2.52,6.81,3.67,11.15,3.67,5.23,0,10.39-1.14,15.27-3.6,8.31-4,12.46-10.58,12.46-19.75v-11.99c-1.84,1.17-4.16,2.16-7.13,2.92-2.79.78-5.61,1.34-8.36,1.66l-9.05,1.16c-5.39.71-9.48,1.87-12.19,3.38-4.64,2.65-6.9,6.74-6.9,12.37,0,4.36,1.52,7.7,4.74,10.19Z"
            fill={secondaryColor}
          />
        </g>
      </g>
    </svg>
  );
};

export default ClinicaDelSol;